module.exports = "<div class=\"content-page-outer-box\"> \n \n  <div class=\"content-box\" *ngIf=\"pageData\">\n      <h1>{{pageData.data.title}}</h1>                    \n      <div class=\"content-body\">\n        {{pageData.data.description}}\n      </div>\n  </div>\n   \n</div>"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/page/page.component.html
// module id = ../../../../../src/app/home/page/page.component.html
// module chunks = common